import type {
  GetPaymentsParams,
  GetPaymentsResponse,
  PaymentDetailDto,
} from "@repo/types";
import apiClient from "../lib/apiClient";

export const getPayments = async (
  params: GetPaymentsParams
): Promise<GetPaymentsResponse> => {
  const response = await apiClient.get<GetPaymentsResponse>("/payment", {
    params,
  });
  return response.data;
};

export const getPaymentDetail = async (
  id: number
): Promise<PaymentDetailDto> => {
  const response = await apiClient.get<PaymentDetailDto>(`/payment/${id}`);
  return response.data;
};


